import { Route, Routes, BrowserRouter } from "react-router-dom";
import Wrapper from "./components/Wrapper";
import { screens } from "./utils/screens";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Wrapper>
        <Routes>
          {screens.map((screen) => (
            <Route
              key={screen.path}
              path={screen.path}
              element={<screen.component />}
            />
          ))}
        </Routes>
      </Wrapper>
    </BrowserRouter>
  );
}

export default App;
